var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "addon-product-container",
      class: _vm.isRecommended ? "recommended" : ""
    },
    [
      _c(
        "div",
        {
          staticClass: "product-image-container",
          class:
            _vm.canAddMore == false && this.currentQty == 0
              ? "disabled"
              : "available"
        },
        [
          _vm.mainBadge != null && _vm.mainBadge != "Trending"
            ? _c("img", {
                staticClass: "main-badge",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/diverse.svg?v=1683569569"
                }
              })
            : _vm.mainBadge == "Trending"
            ? _c("p", { staticClass: "trending-badge" }, [_vm._v("Trending")])
            : _vm._e(),
          _vm._v(" "),
          _vm.secondaryBadge != null && !_vm.isPride
            ? _c("span", { staticClass: "secondary-badge" }, [
                _vm._v(_vm._s(_vm.secondaryBadge))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isPride
            ? _c("img", {
                staticClass: "pride-badge",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/Pride_badge.svg?v=1717085583",
                  loading: "lazy"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            staticClass: "main-image",
            attrs: {
              src:
                "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
              width: "270",
              height: "270",
              loading: "lazy",
              src: _vm._f("getProductImage")(_vm.product)
            },
            on: {
              click: function($event) {
                return _vm.loadModal()
              }
            }
          }),
          _vm._v(" "),
          _vm.product.images.length > 1
            ? _c("img", {
                staticClass: "hover-image",
                attrs: { loading: "lazy", src: _vm.product.images[1].src },
                on: {
                  click: function($event) {
                    return _vm.loadModal()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canAddMore == false && this.currentQty == 0
            ? _c("div", { staticClass: "limit-alert" }, [
                _vm._v(_vm._s(_vm.limitMessage))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isBrandable
            ? _c("img", {
                staticClass: "logo-placeholder",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/logo_grey_2.svg?v=1725379927",
                  alt: "logo here"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isBrandable
            ? _c("div", { staticClass: "edit-float" }, [
                _c("p", [_vm._v("Add your logo")]),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentQty == 0,
                  expression: "currentQty == 0"
                }
              ],
              staticClass: "happybox-button white border",
              attrs: { disabled: _vm.canAddMore == false },
              on: {
                click: function($event) {
                  return _vm.updateProductQuantity(true)
                }
              }
            },
            [_vm._v(_vm._s(_vm.addCopy))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentQty == 0,
              expression: "currentQty == 0"
            }
          ],
          staticClass: "happybox-button white border",
          attrs: { disabled: _vm.canAddMore == false },
          on: {
            click: function($event) {
              return _vm.updateProductQuantity(true)
            }
          }
        },
        [_vm._v(_vm._s(_vm.addCopy))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentQty > 0,
              expression: "currentQty > 0"
            }
          ],
          staticClass: "quantity-container",
          class: !_vm.canAddMore ? "no-more" : ""
        },
        [
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.updateProductQuantity(false)
                }
              }
            },
            [_vm._v("-")]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.currentQty) + " per box")]),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: { content: _vm.limitMessage, container: false },
                  expression: "{content: limitMessage, container: false}"
                }
              ],
              on: {
                click: function($event) {
                  return _vm.updateProductQuantity(true)
                }
              }
            },
            [_vm._v("+")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-price-container" }, [
        _c("p", { staticClass: "product-title" }, [
          _vm._v(_vm._s(_vm.product.title))
        ]),
        _vm._v(" "),
        _vm.hasComparePrice != null
          ? _c("span", { staticClass: "discount-price" }, [
              _vm._v(_vm._s(_vm._f("moneySaleFormat")(_vm.hasComparePrice)))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "price" }, [
          _vm._v(_vm._s(_vm._f("moneySaleFormat")(_vm.productPrice)))
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "edit-btn" }, [
      _c("img", {
        attrs: {
          loading: "lazy",
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634",
          alt: "edit"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }